module.exports = __webpack_public_path__ + "static/media/unreviewed.a32e878a.svg";